// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"cafec43d","63":"8ee3b46a","90":"37b4045a","330":"7dda6903","334":"6664b193","573":"0e111fa2","592":"adc327f2","604":"21866677","639":"3cc7be2d","647":"b9250718","983":"bfa4a730"}[chunkId] + ".chunk.js";
};